import request from '@/utils/request'
// 行政区划相关接口

export function getAreaTree (query) {
  return request({
    url: 'area/notcheck/tree',
    method: 'get',
    params: query
  })
}

export function getAreaTreeFullname (query) {
  return request({
    url: 'area/notcheck/tree/fullname',
    method: 'get',
    params: query
  })
}
